<template lang="pug">
#usuarios
    BaseHeader(
        :titulo="$t('mensagens.usuarios.titulo')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.usuarios.cadastro')",
        :exibeBotao='true',
        @btnHeaderClicado='alterarMostrarModalCadastrarUsuario'
    )

    .view-container-base-header
        .usuarios__barra-pesquisa
            i.el-icon-search
            input.lista-usuarios__barra-pesquisa__input(
                v-model='pagina.filter',
                type='text',
                :placeholder="$t('mensagens.usuarios.pesquisaInteligente')",
                autocomplete='off',
                @keyup.enter='onChangeSearchInput'
            )

        .tabela
            el-table(
                height='calc(100% - 57px)',
                :data='usuarios',
                v-loading='loading',
                @sort-change='ordenar'
            )
                el-table-column(
                    prop='firstName',
                    :label="$t('mensagens.usuarios.tabela.nome')",
                    min-width='300',
                    sortable
                )
                    .template(slot-scope='scope')
                        p.nome {{ `${scope.row.firstName || ''} ${scope.row.lastName || ''}` }}
                            em(v-if='scope.row.isAdmin') administrador

                el-table-column(prop='email', :label="$t('mensagens.usuarios.tabela.email.label')", min-width='300')
                el-table-column(prop='group', :label="$t('mensagens.usuarios.empresa')", min-width='200')
                el-table-column(
                    prop='enabled',
                    :label="$t('mensagens.usuarios.tabela.email.statusLabel')",
                    min-width='150'
                )
                    .template(slot-scope='scope')
                        div(
                            :class='[scope.row.requiredActions.length === 0 ? "verificado" : "nao-verificado"]'
                        )
                            | {{ scope.row.requiredActions.length === 0 ? $t('mensagens.usuarios.tabela.email.statusVerificado') : $t('mensagens.usuarios.tabela.email.statusNaoVerificado') }}

                el-table-column(
                    prop='enabled',
                    :label="$t('mensagens.usuarios.tabela.statusUsuario.label')",
                    min-width='150'
                )
                    .template(slot-scope='scope')
                        div(:class='[scope.row.enabled ? "ativo" : "inativo"]')
                            | {{ scope.row.enabled ? $t('mensagens.usuarios.tabela.statusUsuario.ativo') : $t('mensagens.usuarios.tabela.statusUsuario.inativo') }}

                el-table-column(min-width='100', align='center', :label="$t('mensagens.usuarios.tabela.acoes.label')")
                    .template(slot-scope='scope')
                        el-dropdown.acoes(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical

                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='abrirModalEditarUsuario(scope.row)'
                                )
                                    | {{ $t('mensagens.usuarios.tabela.acoes.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-s-promotion',
                                    @click.native='reenviarEmail(scope.row)'
                                )
                                    | {{ $t('mensagens.usuarios.tabela.acoes.emailAcesso') }}

                                el-dropdown-item(
                                    :icon='scope.row.enabled ? "el-icon-remove-outline" : "el-icon-circle-check"',
                                    @click.native='acaoAlterarStatus(scope.row)'
                                )
                                    | {{ scope.row.enabled ? $t('mensagens.usuarios.tabela.acoes.desativar') : $t('mensagens.usuarios.tabela.acoes.ativar') }}

                template(slot='empty')
                    el-empty(:description="$t('mensagens.usuarios.emptyTemplate')")

            .py-3.btn-paginacao(style='text-align: center')
                el-pagination(
                    background,
                    :page-size='20',
                    :current-page.sync='pagina.page',
                    layout='prev, pager, next',
                    :total='totalUsuarios',
                    @current-change='getUsuarios'
                )

    el-dialog.modal-cadastrar-usuario(
        :title="$t('mensagens.usuarios.cadastro')",
        :visible.sync='mostrarModalCadastrarUsuario',
        width='500px',
        :before-close='alterarMostrarModalCadastrarUsuario',
        :close-on-click-modal='false'
    )
        el-form(:model='novoUsuario')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.nome') }}
                    span.erro(v-if='$v.novoUsuario.nome.$invalid') *
                el-input(v-model='novoUsuario.nome')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.email.label') }}
                    span.erro(v-if='$v.novoUsuario.email.$invalid') *
                el-input(v-model='novoUsuario.email')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.empresa') }}
                    span.erro(v-if='$v.novoUsuario.idEmpresa.$invalid') *
                el-select(
                    v-model='novoUsuario.idEmpresa',
                    :placeholder="$t('mensagens.usuarios.modalUsuario.buscaPorNome')",
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod'
                )
                    el-option(
                        v-for='empresa in empresas',
                        :key='"empresa" + empresa.id',
                        :label='empresa.name',
                        :value='empresa.id'
                    )

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.modalUsuario.perfil') }}
                    span.erro(v-if='$v.novoUsuario.idRole.$invalid') *
                el-select(
                    v-model='novoUsuario.idRole',
                    multiple
                    :placeholder="$t('mensagens.usuarios.modalUsuario.selecionar')",
                    value-key='id',
                    clearable
                )
                    el-option(
                        v-for='role in rolesOperacao',
                        :key='"role" + role.id',
                        :label='role.description',
                        :value='role.id'
                    )

        footer(slot='footer')
            BaseButton(
                size='mini',
                @click='alterarMostrarModalCadastrarUsuario'
            ) {{ $t('mensagens.usuarios.modalUsuario.cancelar') }}
            BaseButton(
                :disabled='$v.novoUsuario.$invalid',
                size='mini',
                type='primary',
                @click='cadastrarUsuario'
            ) {{ $t('mensagens.usuarios.modalUsuario.cadastrar') }}

    el-dialog.modal-editar-usuario(
        :title="$t('mensagens.usuarios.editarUsuario.editar')",
        :visible.sync='mostrarModalEditarUsuario',
        width='500px',
        :before-close='fecharModalEditarUsuario',
        :close-on-click-modal='false'
    )
        el-form(:model='editarUsuario')
            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.nome') }}
                    span.erro(v-if='$v.editarUsuario.nome.$invalid') *
                el-input(v-model='editarUsuario.nome')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.tabela.email.label') }}
                    span.erro(v-if='$v.editarUsuario.email.$invalid') *
                el-input(v-model='editarUsuario.email')

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.empresa') }}
                    span.erro(v-if='$v.editarUsuario.idEmpresa.$invalid') *
                el-select(
                    v-model='editarUsuario.idEmpresa',
                    :placeholder="$t('mensagens.usuarios.modalUsuario.buscaPorNome')",
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod'
                )
                    el-option(
                        v-for='empresa in empresas',
                        :key='"empresa" + empresa.id',
                        :label='empresa.name',
                        :value='empresa.id'
                    )

            el-form-item
                .label(slot='label')
                    span {{ $t('mensagens.usuarios.modalUsuario.perfil') }}
                    span.erro(v-if='$v.editarUsuario.idRole.$invalid') *
                el-select(
                    v-model='editarUsuario.idRole',
                    multiple
                    :placeholder="$t('mensagens.usuarios.modalUsuario.selecionar')",
                    value-key='id',
                    clearable
                )
                    el-option(
                        v-for='role in rolesOperacao',
                        :key='role.id',
                        :label='role.description',
                        :value='role.id'
                    )

        footer(slot='footer')
            BaseButton(size='mini', @click='fecharModalEditarUsuario') {{ $t('mensagens.usuarios.modalUsuario.cancelar') }}
            BaseButton(
                :disabled='$v.editarUsuario.$invalid',
                size='mini',
                type='primary',
                @click='enviarUsuarioEditado'
            ) {{ $t('mensagens.usuarios.editarUsuario.editar') }}

    el-dialog.modal-altera-status(
        :visible.sync='mostrarModalAlterarStatus',
        width='500px',
        :before-close='alterarModalAlterarStatus'
    )
        h2 {{ `${$t('mensagens.usuarios.editarUsuario.textoAlteracao1')} ${alterarStatusUsuario.status ? $t('mensagens.usuarios.editarUsuario.textoAlteracaoDesativar') : $t('mensagens.usuarios.editarUsuario.textoAlteracaoAtivar')} ${$t('mensagens.usuarios.editarUsuario.textoAlteracao2')} ${alterarStatusUsuario.nome.trim()}?` }}
        footer(slot='footer')
            BaseButton(size='mini', @click='alterarModalAlterarStatus') {{ $t('mensagens.usuarios.modalUsuario.cancelar') }}
            BaseButton(size='mini', type='primary', @click='alterarStatus') {{ alterarStatusUsuario.status ? $t('mensagens.usuarios.tabela.acoes.desativar') : $t('mensagens.usuarios.tabela.acoes.ativar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import UsuarioService from '@/services/UsuarioService';
import { required, email } from 'vuelidate/lib/validators';

export default {
    name: 'Usuarios',
    components: {
        BaseHeader,
        BaseButton
    },
    data() {
        return {
            usuarios: [],
            empresas: [],
            rolesOperacao: [],
            totalUsuarios: 0,
            pagina: {
                page: 1,
                filter: ''
            },

            mostrarModalCadastrarUsuario: false,
            novoUsuario: {
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: ''
            },

            mostrarModalEditarUsuario: false,
            editarUsuario: {
                id: '',
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: ''
            },

            mostrarModalAlterarStatus: false,
            alterarStatusUsuario: {
                nome: '',
                status: false
            },
            ordem: null,
            loading: false
        };
    },

    validations() {
        return {
            novoUsuario: {
                nome: { required },
                email: { required, email },
                idEmpresa: { required },
                idRole: { required }
            },
            editarUsuario: {
                nome: { required },
                email: { required, email },
                idEmpresa: { required },
                idRole: { required }
            }
        };
    },

    watch: {
        'novoUsuario.email': function () {
            this.novoUsuario.email = this.novoUsuario.email.trim();
        }
    },

    created() {
        this.getUsuarios();
        this.buscarPerfis();
    },

    methods: {
        async getUsuarios() {
            try {
                this.loading = true;
                const { data } = await UsuarioService.getAll({
                    page: this.pagina.page - 1,
                    filter: this.pagina.filter.replaceAll('.', '').replace('-', ''),
                    order: this.ordem
                });
                this.usuarios = data.users;
                this.totalUsuarios = data.totalUsers;
            } catch (error) {
                this.$notify.error({
                    message: error
                });
            } finally {
                this.loading = false;
            }
        },

        buscarEmpresasSubEmpresas(query) {
            UsuarioService.buscarEmpresasSubEmpresas(this.getFiltros(query))
                .then(({ data }) => {
                    this.empresas = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        remoteMethod(query) {
            setTimeout(() => {
                this.buscarEmpresasSubEmpresas(query);
            }, 500);
        },

        getFiltros(query) {
            return query || '';
        },

        buscarPerfis() {
            UsuarioService.buscarPerfis()
                .then(({ data }) => {
                    this.rolesOperacao = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        onChangeSearchInput() {
            this.getUsuarios();
        },

        alterarMostrarModalCadastrarUsuario() {
            this.limparModalCadastrarUsuario();
            this.mostrarModalCadastrarUsuario =
                !this.mostrarModalCadastrarUsuario;

            if (this.mostrarModalCadastrarUsuario) {
                this.buscarEmpresasSubEmpresas('');
            }
        },

        limparModalCadastrarUsuario() {
            this.novoUsuario = {
                nome: '',
                email: '',
                administrador: false,
                empresa: {},
                idRole: ''
            };
        },

        cadastrarUsuario() {
            const empresaSelecionada = this.empresas.find(
                e => e.id === this.novoUsuario.idEmpresa
            );
            this.novoUsuario.empresa = empresaSelecionada;

            UsuarioService.getbyEmail(
                this.novoUsuario.email.replaceAll('.', ',')
            ).then(({ data }) => {
                if (data.length > 0) {
                    this.$notify.error({
                        message:
                            'E-mail já cadastrado no sistema, por favor inserir outro.'
                    });
                } else {
                    this.salvarUsuario();
                }
            });
        },

        salvarUsuario() {
            UsuarioService.save({
                nome: this.novoUsuario.nome,
                email: this.novoUsuario.email,
                isAdmin: this.novoUsuario.administrador,
                pathEmpresa: this.novoUsuario.empresa.path,
                empresa: this.novoUsuario.empresa.id,
                idRole: this.novoUsuario.idRole
            })
                .then(() => {
                    this.$notify.success({
                        message:
                            'Usuário cadastrado com sucesso! Foi enviado uma mensagem com instruções de acesso para o e-mail informado'
                    });
                    this.alterarMostrarModalCadastrarUsuario();
                    setTimeout(() => {
                        this.getUsuarios();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao cadastrar o usuário: ${error}`
                    });
                });
        },

        abrirModalEditarUsuario({
            id,
            name,
            email,
            isAdmin,
            isSubGroup,
            group,
            idGroup,
            role
        }) {
            this.editarUsuario = {
                id,
                nome: name,
                email,
                administrador: isAdmin,
                idEmpresa: idGroup,
                idRole: role.map(item => item.id)
            };

            this.buscarEmpresasSubEmpresas('');

            this.mostrarModalEditarUsuario = true;
        },

        fecharModalEditarUsuario() {
            this.mostrarModalEditarUsuario = false;
        },

        enviarUsuarioEditado() {
            const empresaSelecionada = this.empresas.find(
                e => e.id === this.editarUsuario.idEmpresa
            );
            this.editarUsuario.empresa = empresaSelecionada;

            UsuarioService.edit(
                {
                    nome: this.editarUsuario.nome,
                    email: this.editarUsuario.email,
                    isAdmin: this.editarUsuario.administrador,
                    pathEmpresa: this.editarUsuario.empresa.path,
                    idEmpresa: this.editarUsuario.empresa.id,
                    idRole: this.editarUsuario.idRole
                },
                this.editarUsuario.id
            )
                .then(() => {
                    this.$notify.success({
                        message: 'Usuário editado com sucesso!'
                    });
                    this.fecharModalEditarUsuario();
                    setTimeout(() => {
                        this.getUsuarios();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao editar o usuário: ${error}`
                    });
                });
        },

        acaoAlterarStatus({ id, enabled, firstName, lastName }) {
            this.alterarStatusUsuario = {
                nome: `${firstName} ${lastName}`,
                status: enabled,
                id
            };
            this.alterarModalAlterarStatus();
        },

        alterarModalAlterarStatus() {
            this.mostrarModalAlterarStatus = !this.mostrarModalAlterarStatus;
        },

        alterarStatus() {
            UsuarioService.changeEnabled(
                this.alterarStatusUsuario.id,
                !this.alterarStatusUsuario.status
            )
                .then(() => {
                    this.$notify.success({
                        message: this.alterarStatusUsuario.status
                            ? 'Usuário inativado com sucesso!'
                            : 'Usuário ativado com sucesso!'
                    });
                    this.alterarModalAlterarStatus();
                    setTimeout(() => {
                        this.getUsuarios();
                    }, 1000);
                })
                .catch(error => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao ${
                            this.alterarStatusUsuario.status
                                ? 'inativar'
                                : 'ativar'
                        } o usuário: ${error}`
                    });
                });
        },

        reenviarEmail({ id, email }) {
            UsuarioService.sendEmail(id)
                .then(() => {
                    this.$notify.success({
                        message: `E-mail com instruções de primeiro acesso enviado com sucesso!`
                    });
                })
                .catch(erro => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao enviar o e-mail: ${erro}`
                    });
                });
        },

        ordenar({ order }) {
            if (order === null) {
                this.ordem = null;
                return;
            }

            this.ordem = order === 'ascending' ? 'ASC' : 'DESC';
            this.getUsuarios();
        }
    }
};
</script>

<style lang="scss">
#usuarios {
    header .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .usuarios__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-usuarios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .pagination {
        background-color: var(--white);
        border-radius: 0 0 2px 2px;
        justify-content: center;
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: calc(100vh - 258px);
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;

        .acoes:hover {
            cursor: pointer;
        }
    }

    .nome {
        em {
            font-size: 12px;
            background-color: #d1ead2;
            border: 1px solid #bae0bc;
            border-radius: 4px;
            padding: 0 4px;
            margin-left: 8px;
        }
    }

    .verificado,
    .nao-verificado,
    .ativo,
    .inativo {
        border-radius: 20px;
        text-align: center;
        max-width: 120px;
        color: var(--black);
    }

    .verificado,
    .ativo {
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
    }

    .nao-verificado,
    .inativo {
        background-color: #ffaeae;
        border: 1px solid var(--danger);
    }

    .modal-cadastrar-usuario,
    .modal-editar-usuario,
    .modal-altera-status {
        footer {
            display: flex;
            justify-content: space-between;

            .el-button {
                width: 80px;
            }
        }

        .label {
            display: flex;
            align-items: center;
            gap: 4px;
        }

        .label-line {
            display: block;
        }

        .erroInput {
            border-radius: 4px;
            border: 1px solid red;
        }

        .erro {
            color: red;
            font-size: 10px;
            display: block;
            line-height: 1.5;
        }

        .el-form-item__label {
            margin-bottom: -10px;
        }
    }
    .el-select {
        width: 460px;
    }
}
</style>
